"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergePackageMaps = exports.updatePackages = void 0;
/* eslint-disable functional/prefer-readonly-type */
const isNotNil_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/isNotNil"));
const immutable_1 = require("immutable");
/**
 *
 * Update existing packages with any new values without adding any new packages.
 * The packages fetched during the build have child types filtered out,
 * and we don't want to add them back in.
 *
 */
const updatePackages = (oldPackages) => (newPackages) => (0, exports.mergePackageMaps)(oldPackages, newPackages);
exports.updatePackages = updatePackages;
/**
 * Merge two maps of packages keyed by strings (presumably SKUs)
 *
 * This came about because Map.mergeDeep was choking on Maybe as a value
 * (eg "(TypeError): Expected [K, V] tuple")
 *
 * This function returns the first map with keys overwritten by the second map only if they're non-null values.
 * By design it does not, and should not, add new keys.
 */
const mergePackageMaps = (originalPackages, newPackages) => (0, immutable_1.Map)((0, immutable_1.List)(originalPackages.entries())
    .reduce((acc, [key, val]) => ({
    ...acc,
    [key]: newPackages.has(key) && (0, isNotNil_1.default)(newPackages.get(key)) ? newPackages.get(key) : val
}), {}));
exports.mergePackageMaps = mergePackageMaps;
//# sourceMappingURL=utils.js.map